var _path, _path2, _circle, _circle2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8623 13.0721V9.29898C5.88934 7.15632 6.75307 5.11067 8.26639 3.60512C9.77972 2.09958 11.8208 1.25537 13.9475 1.25537C16.0742 1.25537 18.1152 2.09958 19.6285 3.60512C21.1419 5.11067 22.0056 7.15632 22.0326 9.29898V13.0721",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.008 12.4502H0.886719V31.1083H27.008V12.4502Z",
    fill: "#DFDFDF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.34983,
    cy: 19.9135,
    r: 1.24387,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5447,
    cy: 19.9135,
    r: 1.24387,
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.59375,
    y1: 22.8951,
    x2: 18.3008,
    y2: 22.8951,
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c5f1a758f360149ab766c91224dff834.svg";
export { ForwardRef as ReactComponent };